import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { TechnicianService } from 'src/app/services/technician.service';
import { ToastrService } from 'ngx-toastr';
import { PrevConfigurationService } from 'src/app/services/prev-configuration.service';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-prev-task-checklist-execution',
  templateUrl: './prev-task-checklist-execution.component.html',
  styleUrls: ['./prev-task-checklist-execution.component.scss'],
})
export class PrevTaskChecklistExecutionComponent implements OnInit {
  @Input() taskId!: number;

  @Input() technicianTaskId!: number;

  @Input() isviewMode!: boolean;

  @Output() checklistUpdated = new EventEmitter<void>();

  checkListAddModel = new MatTableDataSource<any | Group>([]);

  doc!: any;

  itemColumns: string[] = [
    'items',
    'good',
    'bad',
    'standard',
    'minimum',
    'maximum',
    'score',
    'remarks',
  ];

  images: any[] = [];

  goodImgArray: File[] = [];

  displayMaximizable = false;

  detailPrentId!: any;

  _alldata!: any[];

  groupByColumns: string[] = [];

  yes = true;

  no = true;

  fileSave!: any;

  fileType: any;

  GoodExampleImage = false;

  BadExampleImage = false;

  counter = 1;

  categoryTypeDDL: any[] = [
    { id: 'Yes', name: 'Yes' },
    { id: 'No', name: 'No' },
  ];

  addtabledata: Array<any> = [];

  imageIndexOne = 0;

  blobUrl: string = environment.blobStorageUrl;

  displayUploadedFile: boolean = false;

  uploadedfileType: string = '';

  uploadedimages: any[] = [];

  uploadeddoc: any;

  CheckLists: any[] = [];
  ChecklistIds: any;
  CheckListNames: any[] = [];
  CheckListDetails: any[] = [];

  activeTabIndex: number = 0;
  dataSources: { [key: string]: MatTableDataSource<any> } = {};
  dataSource = new MatTableDataSource<any>();

  isChecklistDetailsFetched = false;
  constructor(
    private spinner: NgxSpinnerService,
    private technicianService: TechnicianService,
    private toaster: ToastrService,
    private PrevConfigurationService: PrevConfigurationService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.groupByColumns = ['itemGroup'];
    this.PrevConfigurationService.onDataChange(() => {
      this.getChecklistNames();
    });
  }

  getChecklistNames(): void {
    const data = this.PrevConfigurationService.getChecklistExecPMData();

    if (data && data.length > 0) {
      this.CheckLists = data;
      this.CheckListNames = data.map((item) => item.listName);

      if (!this.isChecklistDetailsFetched) {
        var unit = this.technicianService.unit;
        const payload = {
          UnitId: unit ? unit : data[0].PuId,
          ChecklistId: data.map((item) => item.checkListId).join(','),
          TaskId: this.taskId,
          ExecutionId: data.map(item => item.ExecutionId || 0).join(','),
        };



        this.GetQualityChecklistPMDetails(payload);
        this.isChecklistDetailsFetched = true;
      }

      this.activeTabIndex = 0;

      if (this.CheckListNames.length > 0) {
        const firstTabName = this.CheckListNames[0];
        this.dataSource = this.getDataForTab(firstTabName);

        this.onTabChange({
          tab: { textLabel: firstTabName },
          index: 0,
        } as MatTabChangeEvent);
      }

      this.cdr.detectChanges();
    }
  }


  // setTabActive(): void {
  //   const matTabLabels = document.querySelector('.mat-tab-labels');

  //   if (matTabLabels) {
  //     const firstMatTabLabel = matTabLabels.querySelector('.mat-tab-label');

  //     if (firstMatTabLabel) {
  //       firstMatTabLabel.classList.add('mat-tab-label-active');
  //     }
  //   }
  // }

  GetQualityChecklistPMDetails(payload: any) {
    const unitid = payload.UnitId;
    this.spinner.show();

    this.PrevConfigurationService.getQualityChecklistPMDetailsData(
      payload
    ).subscribe({
      next: (response: any) => {
        this.spinner.hide();
        this.CheckListDetails = response;

        const flatRes: any[] = [];

        // Flatten the response data
        Object.keys(response).forEach((key) => {
          if (Array.isArray(response[key])) {
            response[key].forEach((item) => {
              item.checkListId = Number(key);
              item.unitId = Number(unitid);
              flatRes.push(item);
            });
          }
        });

        this.addtabledata = [];
        this.goodImgArray = [];

        flatRes.forEach((ele: any, index: number) => {
          if (ele.dropDown && typeof ele.dropDown === 'string') {
            try {
              ele.dropDown = JSON.parse(ele.dropDown);
            } catch (err) {
              console.error('Dropdown JSON parse error', err);
            }
          }

          const execution =
            ele.Execution && Object.keys(ele.Execution).length > 0
              ? ele.Execution
              : ele;

          const row = {
            unitId: unitid,
            checklistId: ele.checkListId,
            id: execution.checkListDetailId,
            item: execution.itemName,
            itemtype: execution.itemType,
            drop: execution.itemGroup,
            taskId: execution.taskId ?? null,
            remarks: execution.remarks ?? '',
            catType: execution.catType ?? '',
            goodImage: ele.goodExampleImage,
            badImage: ele.badExampleImage,
            dropDown: execution.dropDown,
            minValue: ele.minValue,
            maxValue: ele.maxValue,
            standard: ele.standard,
          };

          this.addtabledata.push(row);
          this.goodImgArray.push(new File([''], 'filename'));

          ele.id = index + 1;
          ele.remarks = execution.remarks ?? '';
          ele.catType = execution.catType ?? '';
          // surface values already stored that are not numbers
          ele.valueError =
            execution.itemType === 2 && !this.isNumericValue(ele.catType);
        });

        this._alldata = flatRes;

        // Prepare per-tab data sources
        this.CheckListNames.forEach((tabName) => {
          const filteredData = this._alldata.filter(
            (item) => item.listName === tabName
          );
          this.dataSources[tabName] = new MatTableDataSource(filteredData);
        });

        // Setup the grouped data for the main model
        this.checkListAddModel.data = this.addGroups(
          this._alldata,
          this.groupByColumns
        );
        this.checkListAddModel.filterPredicate =
          this.customFilterPredicate.bind(this);
        this.checkListAddModel.filter = performance.now().toString();

        // Good/Bad image column check
        const goodImage = flatRes.some(
          (element) => element.goodExampleImage?.trim() !== ''
        );
        this.GoodExampleImage = goodImage;
        if (!goodImage) this.removeImagesColumns('good');

        const badImage = flatRes.some(
          (element) => element.badExampleImage?.trim() !== ''
        );
        this.BadExampleImage = badImage;
        if (!badImage) this.removeImagesColumns('bad');

        // ✅ Now set the first tab and its data
        if (this.CheckListNames && this.CheckListNames.length > 0) {
          const firstTabName = this.CheckListNames[0];
          this.dataSource = this.getDataForTab(firstTabName);

          this.onTabChange({
            tab: { textLabel: firstTabName },
            index: 0,
          } as MatTabChangeEvent);
        }

        this.cdr.detectChanges();
      },
      error: (error: any) => {
        this.spinner.hide();
        this.toaster.error('Error', error.ErrorMessage);
      },
    });
  }

  onTabChange(event: MatTabChangeEvent) {
    const tabLabel = event.tab.textLabel;
    if (this._alldata) {
    const tabData = this._alldata.filter((item) => item.listName === tabLabel);
      const groupedData = this.addGroups(tabData, this.groupByColumns);

      const newDataSource = new MatTableDataSource<any>(groupedData);
      newDataSource.filterPredicate = this.customFilterPredicate.bind(this);
      newDataSource.filter = performance.now().toString();

      this.dataSources[tabLabel] = newDataSource;
      this.dataSource = newDataSource;
    }

  }

  getExecutionOrElement(element: any): any {
    return element.Execution && Object.keys(element.Execution).length > 0
      ? element.Execution
      : element;
  }

  getDataForTab(tabName: string): MatTableDataSource<any> {
    if (!this._alldata) {
      console.warn('Data not loaded yet');
      return new MatTableDataSource([]);
    }

    const filteredFlatData = this._alldata.filter(
      (item) => item.listName === tabName
    );
    const groupedData = this.addGroups(filteredFlatData, ['itemGroup']);
    const dataSource = new MatTableDataSource(groupedData);
    dataSource.filterPredicate = this.customFilterPredicate.bind(this);
    dataSource.filter = performance.now().toString();

    return dataSource;
  }

  removeImagesColumns(name: string): void {
    const removeIndex = this.itemColumns.findIndex((i: any) => {
      return i === name;
    });
    if (removeIndex >= 0) {
      const good = this.itemColumns.splice(removeIndex, 1);
    }
  }
  addGroups(data: any[], groupByColumns: string[], level = 0): any[] {
    if (level >= groupByColumns.length) {
      return data;
    }

    const groupedData: any[] = [];
    const currentColumn = groupByColumns[level];
    const uniqueGroupValues = [
      ...new Set(data.map((item) => item[currentColumn])),
    ];

    uniqueGroupValues.forEach((groupValue) => {
      const groupItems = data.filter(
        (item) => item[currentColumn] === groupValue
      );

      const groupHeader: any = {
        isGroup: true,
        level: level + 1,
        expanded: true,
        visible: true,
        [currentColumn]: groupValue, // ✅ required for filtering/grouping
        groupName: groupValue,
      };

      // ✅ specifically include 'itemGroup' if grouping by itemGroup
      if (currentColumn === 'itemGroup') {
        groupHeader.itemGroup = groupValue;
      }

      groupedData.push(groupHeader);

      const children = this.addGroups(groupItems, groupByColumns, level + 1);
      children.forEach((child) => (child.visible = true));
      groupedData.push(...children);
    });

    return groupedData;
  }

  getSublevel(
    data: any[],
    level: number,
    groupByColumns: string[],
    parent: Group
  ): any[] {
    // Recursive function, stop when there are no more levels.
    if (level >= groupByColumns.length) return data;

    var groups = this.uniqueBy(
      data.map((row) => {
        var result = new Group();
        result.level = level + 1;
        result.parent = parent;
        for (var i = 0; i <= level; i++)
          result[groupByColumns[i]] = row[groupByColumns[i]];
        return result;
      }),
      JSON.stringify
    );

    const currentColumn = groupByColumns[level];

    var subGroups = [];
    groups.forEach((group) => {
      let rowsInGroup = data.filter(
        (row) => group[currentColumn] === row[currentColumn]
      );
      let subGroup = this.getSublevel(
        rowsInGroup,
        level + 1,
        groupByColumns,
        group
      );
      subGroup.unshift(group);
      subGroups = subGroups.concat(subGroup);
    });
    return subGroups;
  }

  uniqueBy(a, key) {
    var seen = {};
    return a.filter(function (item) {
      var k = key(item);
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
  }

  openFilePopUp(elem: any, index: number, n: number): void {
    if (n === 1) {
      const array = elem.goodExampleImage.split('.');
      const fileType = array[array.length - 1];
      this.doc = elem.goodExampleImage;
      if (
        fileType === 'jpeg' ||
        fileType === 'jpg' ||
        fileType === 'png' ||
        fileType === 'gif'
      ) {
        this.images = [];
        this.fileType = 'img';
        this.images.push(this.doc);
      } else {
        this.fileType = 'doc';
      }
      const file = this.goodImgArray[index];
      this.displayMaximizable = true;
    } else if (n === 2) {
      const array = elem.badExampleImage.split('.');
      const fileType = array[array.length - 1];
      this.doc = elem.badExampleImage;
      if (
        fileType === 'jpeg' ||
        fileType === 'jpg' ||
        fileType === 'png' ||
        fileType === 'gif'
      ) {
        this.images = [];
        this.fileType = 'img';
        this.images.push(this.doc);
      } else {
        this.fileType = 'doc';
      }
      const file = this.goodImgArray[index];
      this.displayMaximizable = true;
    }
  }
  isGroup = (_: number, row: any) => row.isGroup === true;

  groupHeaderClick(row: any, tabName: string): void {
    row.expanded = !row.expanded;
    const tabDataSource = this.dataSources[tabName];
    if (!tabDataSource) return;

    tabDataSource.data.forEach((item: any) => {
      if (item.itemGroup === row.itemGroup && !item.isGroup) {
        item.visible = row.expanded;
      }
    });

    tabDataSource.filter = performance.now().toString(); // Force re-evaluation
  }

  /** true when the text is a plain float: optional minus, digits, one decimal part */
  isNumericValue(value: any): boolean {
    const text = (value ?? '').toString().trim();
    return text === '' || /^-?\d+(\.\d+)?$/.test(text);
  }

  /** Arabic-Indic digits and the Arabic decimal separator typed on an Arabic keyboard */
  private toWesternDigits(text: string): string {
    return text
      .replace(/[\u0660-\u0669]/g, (d) => String(d.charCodeAt(0) - 0x0660))
      .replace(/[\u06F0-\u06F9]/g, (d) => String(d.charCodeAt(0) - 0x06f0))
      .replace(/[\u066B,]/g, '.');
  }

  /** strips anything that is not part of a float, keeping one dot and a leading minus */
  private sanitizeNumeric(raw: string): string {
    let text = this.toWesternDigits((raw ?? '').toString()).replace(/[^0-9.\-]/g, '');

    const negative = text.startsWith('-');
    text = text.replace(/-/g, '');

    const firstDot = text.indexOf('.');
    if (firstDot !== -1) {
      text = text.slice(0, firstDot + 1) + text.slice(firstDot + 1).replace(/\./g, '');
    }

    return (negative ? '-' : '') + text;
  }

  /** blocks a bad character before it reaches the box - paste is handled on input */
  onValueKeyPress(event: KeyboardEvent): boolean {
    if (event.key.length > 1 || event.ctrlKey || event.metaKey) {
      return true; // Backspace, Tab, arrows, copy/paste shortcuts
    }

    const input = event.target as HTMLInputElement;
    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? input.value.length;
    const next = input.value.slice(0, start) + event.key + input.value.slice(end);

    // allows '', '-', '1.', '-0.5' while typing; rejects letters and a second dot
    if (!/^-?\d*\.?\d*$/.test(this.toWesternDigits(next))) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  /** catches paste, drag-drop and autofill, which never fire keypress */
  onValueInput(event: any, element: any): void {
    const typed = event?.target?.value ?? '';
    const clean = this.sanitizeNumeric(typed);

    if (clean !== typed) {
      event.target.value = clean; // keep the box and the model identical
    }

    element.catType = clean;
    element.valueError = !this.isNumericValue(clean);

    this.scoreUpdate({ target: { value: clean } }, element);
  }

  scoreUpdate(event: any, data: any): void {
    this.detailPrentId = data.id;
    const checklistId = parseInt(data.id, 10);
    const d = this._alldata.find((x) => x.id === checklistId);

    if (!d) return;

    if (data.itemType === 1) {
      const v = event.value;
      d.catType = v;
      if (d.Execution && Object.keys(d.Execution).length > 0) {
        d.Execution.catType = v;
      }
    } else {
      const score = event.target.value === '' ? '' : event.target.value;
      d.catType = score;
      if (d.Execution && Object.keys(d.Execution).length > 0) {
        d.Execution.catType = score;
      }
    }

    this.checklistUpdated.emit();
  }

  onChangeradio(value: any): void {
    if (value.value === 'Yes') {
      this.yes;
    } else {
      this.no;
    }
  }
  // uploadedFile(event: any, Id: number, itemType: any): void {
  //   const maxSizeInMB = 5;
  //   const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

  //   const selectedFile = event.target.files[0];

  //   const extension = selectedFile.name.split('.').pop().toLowerCase();
  //   const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'pdf', 'doc', 'docx'];

  //   if (selectedFile.size > maxSizeInBytes) {
  //     this.toaster.warning(
  //       'File size exceeds 5MB limit. Please upload a smaller file.'
  //     );
  //     event.target.value = '';
  //     return;
  //   }
  //   const d = this._alldata.find((x) => x.id === Id);

  //   if (d) {
  //     const v = event.target.files[0];
  //     d.file = v;
  //     if (d.Execution && Object.keys(d.Execution).length > 0) {
  //       d.Execution.file = v;
  //     }
  //   }

  //   this.checklistUpdated.emit();

  //   const ind = this.addtabledata.findIndex((c: any) => c.id === Id);
  //   const found = this.goodImgArray[ind];
  //   if (found) {
  //     this.goodImgArray[ind] = event.target.files[0];
  //     this.addtabledata[ind].catType = event.target.files[0]?.name;
  //     this._alldata[ind].file = event.target.files[0];
  //   } else {
  //     if (event.target.files.length > 0) {
  //       this.fileSave = event.target.files[0];
  //       this._alldata[ind].fileName = event.target.files[0];
  //       this.addtabledata[ind].catType = event.target.files[0].name;
  //       this.goodImgArray.push(this.fileSave);
  //     }
  //   }
  // }

  uploadedFile(event: any, Id: number, itemType: any): void {
    const maxSizeInMB = 5;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    const selectedFile = event.target.files[0];

    if (!selectedFile) {
      return;
    }

    const extension = selectedFile.name.split('.').pop().toLowerCase();

    // Define allowed extensions based on itemType
    let allowedExtensions: string[] = [];

    if (itemType === 4) {
      allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx', 'xls', 'xlsx'];
    } else if (itemType === 6) {
      allowedExtensions = ['jpg', 'jpeg', 'png'];
    }

    // File size check
    if (selectedFile.size > maxSizeInBytes) {
      this.toaster.warning('File size exceeds 5MB limit. Please upload a smaller file.');
      event.target.value = '';
      return;
    }

    // File extension check
    if (!allowedExtensions.includes(extension)) {
      this.toaster.warning(`Invalid file type. Allowed types: ${allowedExtensions.join(', ')}`);
      event.target.value = '';
      return;
    }

    const d = this._alldata.find((x) => x.id === Id);

    if (d) {
      d.file = selectedFile;
      if (d.Execution && Object.keys(d.Execution).length > 0) {
        d.Execution.file = selectedFile;
      }
    }

    this.checklistUpdated.emit();

    const ind = this.addtabledata.findIndex((c: any) => c.id === Id);
    const found = this.goodImgArray[ind];

    if (found) {
      this.goodImgArray[ind] = selectedFile;
      this.addtabledata[ind].catType = selectedFile.name;
      this._alldata[ind].file = selectedFile;
    } else {
      if (event.target.files.length > 0) {
        this.fileSave = selectedFile;
        this._alldata[ind].fileName = selectedFile;
        this.addtabledata[ind].catType = selectedFile.name;
        this.goodImgArray.push(this.fileSave);
      }
    }
  }


  customFilterPredicate(data: any, filter: string): boolean {
    if (data.isGroup) {
      return data.visible !== false;
    } else {
      return this.getDataRowVisible(data);
    }
  }

  getDataRowVisible(data: any): boolean {
    const groupRows = this.checkListAddModel.data.filter((row) => {
      if (!row.isGroup) return false;

      return this.groupByColumns.every(
        (column) => row[column] === data[column]
      );
    });

    if (groupRows.length === 0) return true;
    const parent = groupRows[0];

    return parent.visible !== false && parent.expanded;
  }
  onDateChange(event: any, element: any): void {
    const checklistId = parseInt(element.id, 10);
    const d = this._alldata.find((x) => x.id === checklistId);
    if (!d) return;

    const selectedDate = event.target.value;
    d.catType = selectedDate;

    if (d.Execution && Object.keys(d.Execution).length > 0) {
      d.Execution.catType = selectedDate;
    }

    this.checklistUpdated.emit();
  }
  OnDropdownUpdate(event: any, data: any): void {
    const checklistId = parseInt(data.id, 10);
    const d = this._alldata.find((x) => x.id === checklistId);
    if (!d) return;

    if (d.itemType === 5) {
      const v = event.value;
      d.catType = v;

      if (d.Execution && Object.keys(d.Execution).length > 0) {
        d.Execution.catType = v;
      }
    }

    this.checklistUpdated.emit();
  }
  remarksUpdate(event: any, data: any): void {
    const remarks = event.target.value;
    const checklistId = parseInt(data.id, 10);
    const m = this._alldata.find((x) => x.id === checklistId);
    m.remarks = remarks;
    if (m.Execution && Object.keys(m.Execution).length > 0) {
      m.Execution.remarks = remarks;
    }
  }
  get alldata(): any[] {
    return this._alldata;
  }
  hasFile(element: any): boolean {
    const index = this.addtabledata.findIndex((c: any) => c.id === element.Id);
    const file = this.goodImgArray[index];
    const row = this.addtabledata[index];

    return !!((file && file.type) || element?.Execution_FilePath);
  }
  openImage(elem: any): void {
    const index = this.addtabledata.findIndex((c: any) => c.id === elem.id);
    const uploadedFile = this.goodImgArray[index];

    // Case 1: If file is uploaded and has type
    if (uploadedFile && uploadedFile.type) {
      const reader = new FileReader();

      reader.onload = () => {
        const base64 = reader.result as string;
        const fileType = uploadedFile.type;

        if (fileType.startsWith('image/')) {
          this.fileType = 'img';
          this.images = [base64];
          this.imageIndexOne = 0;
        } else {
          this.fileType = 'doc';
          this.doc = base64;
        }

        this.displayMaximizable = true;
      };

      reader.onerror = () => {
        this.toaster.error('Failed to read file.');
      };

      reader.readAsDataURL(uploadedFile);
    }

    // Case 2: No uploaded file, but Execution_FilePath exists
    else if (elem.Execution.catType) {
      const fileUrl = elem.Execution.catType;
      const fileType = this.getFileTypeFromExtension(fileUrl);

      if (fileType === 'img') {
        this.fileType = 'img';
        this.images = [fileUrl];
        this.imageIndexOne = 0;
      } else if (fileType === 'doc') {
        this.fileType = 'doc';
        this.doc = fileUrl;
      } else {
        this.toaster.warning('Unsupported file type.');
        return;
      }

      this.displayMaximizable = true;
    } else {
      this.toaster.warning('No file uploaded or linked.');
    }
  }
  getFileTypeFromExtension(fileUrl: string): 'img' | 'doc' | 'unknown' {
    const extension = fileUrl.split('.').pop()?.toLowerCase();

    if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(extension))
      return 'img';

    if (['pdf', 'doc', 'docx'].includes(extension)) return 'doc';

    return 'unknown';
  }

  compareIds = (a: any, b: any): boolean => {
    return +a === +b; // ensures numeric comparison even if one is string
  };
}
export class Group {
  level: number = 0;
  parent: Group;
  expanded: boolean = true;
  itemGroup: string;
  totalCounts: number = 0;
  get visible(): boolean {
    return !this.parent || (this.parent.visible && this.parent.expanded);
  }
}
